
const swipers = new Swiper('.event_section_locations .article_slider', {
    // Optional parameters
    loop: true,
    slidesPerView:1.29,
    autoHeight: true,
    spaceBetween:16,
    navigation: {
        nextEl: '.event_section_locations .swiper-button-next',
        prevEl: '.event_section_locations .swiper-button-prev',
    },
    breakpoints: {
        750: {
            slidesPerView: '2',
        },
        1024:{
            slidesPerView: '3',
        }
    } 
});

